import { getImageUrl } from "../../helpers/getImageUrl";
import { getFrontendUrl } from "../../helpers/utils";
import { Product } from "../../types/Product";
import { uniqBy } from "lodash";

function getAdditionalImages(product: Product) {
  if (product.type !== "PHOTO") {
    return [];
  }
  try {
    const productInHomes = product.in_homes.map((c) => c.in_home);
    const relatedInHomes = product.related_in_homes;
    const allInHomes = [...productInHomes, ...relatedInHomes];
    const inHomes = uniqBy(allInHomes, ({ id }) => id);
    const images = inHomes
      .slice(0, 5)
      .map((inHome) => getImageUrl(inHome.image));
    return images;
  } catch (error) {
    console.error(error);
    return [];
  }
}

function getOffers(product: Product) {
  if (product.sold_out) {
    return {};
  }

  if (product.type === "PHOTO" || product.type === "PAIRING") {
    if (product.sizes) {
      return {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        price: product.sizes[0] ? product.sizes[0].price : 0,
        priceCurrency: "USD",
        url: getFrontendUrl(`/shop/${product.slug}`),
      };
    }
  }

  if (product.price) {
    return {
      "@type": "Offer",
      availability: "https://schema.org/InStock",
      price: product.price,
      priceCurrency: "USD",
      url: getFrontendUrl(`/shop/${product.slug}`),
    };
  }

  return {};
}

export function getRichSnippet(product: Product, isPinterestBot: boolean) {
  const organisation = {
    "@id": getFrontendUrl("/#organisation"),
  };

  const common = {
    "@type": "Product",
    "@id": getFrontendUrl(`/#shop/${product.slug}`),
    productId: `${product.id}`,
    name: product.name,
    url: getFrontendUrl(`/shop/${product.slug}`),
    description: product.description,
    keywords: product.keywords,
    image: [getImageUrl(product.featured_image)],
    offers: getOffers(product),
    category: product.serie ? product.serie.name : "",
    brand: organisation,
    manufacturer: organisation,
    gtin13: product.serial_number,
  };

  if (isPinterestBot) {
    if (product.pinterest_title) {
      common.name = product.pinterest_title;
    }
    if (product.pinterest_description) {
      common.description = product.pinterest_description;
    }
    common.productId = `${product.id}`;
  }

  if (product.type === "PHOTO" || product.type === "PAIRING") {
    const images = getAdditionalImages(product);
    common.image = [...common.image, ...images];

    return {
      ...common,
      itemCondition: "NewCondition",
      alternateName: product.alt,
      productionDate: product.production_date
        ? new Date(product.production_date).toISOString()
        : undefined,
      color: product.color,
      award: product.awards.length ? product.awards[0].reward : "",
      material: product.material,
    };
  }

  if (product.type === "BOOK") {
    return {
      ...common,
      "@type": "Book",
      illustrator: product.book_author,
      author: product.book_author,
      bookEdition: product.book_edition,
      bookFormat: product.book_format,
      datePublished: new Date(product.production_date).toISOString(),
      isbn: product.serial_number,
    };
  }

  return common;
}
